import type { ErrorAction } from '../core/errorAction';
import { isRetryableError } from './retryPolicy';

export interface ActionPolicyInput {
  supportsRetry: boolean;
  errorCode?: string;
  httpStatus?: number;
}

/**
 * Only show Retry when the screen wires a real retry handler (design doc §8.1).
 */
export function buildRetryActionIfAllowed(input: ActionPolicyInput): ErrorAction | null {
  if (!input.supportsRetry) return null;
  if (!isRetryableError(input.errorCode, input.httpStatus)) return null;
  return { kind: 'retry', label: 'Retry' };
}
